import { FontPickerConfigInterface } from 'ngx-font-picker';
import { environment } from 'src/environments/environment';

export const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
    apiKey: environment.googleKey
  };